import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers/rootReducer";
import { Trans, useTranslation } from "react-i18next";
import Button from "./Button";
import LanguageList from "./LanguageList";
import BlackFridayDealsPill from "./BlackFriday/BlackFridayDealsPill";
import { goTo } from "../utilities/utils";
import { useI18next } from "gatsby-plugin-react-i18next";
import { goToPlansWithParams } from "../utilities/utils";

interface RightNavProps {
  open: boolean;
  setOpen: Function;
}

const RightNav: React.FC<RightNavProps> = (props: RightNavProps) => {
  let routeDetails = useSelector((state: RootState) => {
    return state.route;
  });

  const { t } = useTranslation();
  const { language } = useI18next();
  const onPartnerPage = routeDetails.routeString === "partners";

  const [esimLink, setEsimLink] = useState("https://esim.gophonebox.com/");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.size > 0) {
      const affiliateEsimLink =
        "https://esim.gophonebox.com/?" + params.toString();
      setEsimLink(affiliateEsimLink);
    } else if (sessionStorage.getItem("raLink")) {
      setEsimLink("https://esim.gophonebox.com/?bn=4036");
    }
  }, []);

  // due to development constraints, these languages are only partially supported
  const specialLanguages = ["jp", "zh", "vi", "pt", "ko"];
  const isSpecialLanguage = specialLanguages.includes(language);

  const activationTextForDisplay = isSpecialLanguage ? (
    "Activation"
  ) : (
    <Trans>Activation</Trans>
  );
  const esimTextForDisplay = isSpecialLanguage ? "eSIM" : <Trans>eSIM</Trans>;

  const [isOpened, setIsOpened] = React.useState(false);

  const Line = () => {
    return (
      <hr
        style={{
          color: "#0494CA",
          backgroundColor: "#0494CA",
          height: 1,
          padding: 0,
          margin: 0,
        }}
      />
    );
  };

  const openSupportMenu = () => {
    setIsOpened(!isOpened);
  };

  const headerRef = useRef();
  const closeByRef = (e) => {
    if (headerRef.current === e.target) {
      props.setOpen(false);
    }
  };

  return (
    <Background ref={headerRef} onClick={closeByRef} open={props.open}>
      <Ul open={props.open}>
        <li style={{ marginTop: 15 }}>
          <NavItem>
            <Menu>
              <Trans>Menu</Trans>
            </Menu>
          </NavItem>
          <Line />
        </li>
        {onPartnerPage ? null : (
          <>
            <li>
              <a onClick={() => goToPlansWithParams("ca")}>
                <NavItem>
                  <Text path={routeDetails.routeString} matchPath="">
                    <Trans>Canada Plans</Trans>
                  </Text>
                  {/* <BlackFridayDealsPill text="Black Friday Deals" /> */}
                  <RightArrow
                    src="/images/right-arrow.png"
                    width={20}
                    height={20}
                  />
                </NavItem>
                <Line />
              </a>
            </li>
            <li>
              <a onClick={() => goToPlansWithParams("us")}>
                <NavItem>
                  <Text path={routeDetails.routeString} matchPath="">
                    <Trans>U.S. Plans</Trans>
                  </Text>
                  {/* <BlackFridayDealsPill text="Black Friday Deals" /> */}
                  <RightArrow
                    src="/images/right-arrow.png"
                    width={20}
                    height={20}
                  />
                </NavItem>
                <Line />
              </a>
            </li>
            <li>
              <a
                onClick={() => goTo("/global-esim", undefined, undefined, true)}
              >
                <NavItem>
                  <Text path={routeDetails.routeString} matchPath="global-esim">
                    <Trans>Global Plans</Trans>
                  </Text>
                  {/* <BlackFridayDealsPill text="Black Friday Deals" /> */}
                  <RightArrow
                    src="/images/right-arrow.png"
                    width={20}
                    height={20}
                  />
                </NavItem>
                <Line />
              </a>
            </li>
            <li>
              <a
                onClick={() =>
                  goTo("/home-internet", undefined, undefined, true)
                }
              >
                <NavItem>
                  <Text
                    path={routeDetails.routeString}
                    matchPath="home-internet"
                  >
                    <Trans>Home Internet</Trans>
                  </Text>
                  {/* <BlackFridayDealsPill text="Holiday Sales" /> */}
                  <RightArrow
                    src="/images/right-arrow.png"
                    width={20}
                    height={20}
                  />
                </NavItem>
                <Line />
              </a>
            </li>
            <li>
              <a
                onClick={() => goTo("/activation", undefined, undefined, true)}
              >
                <NavItem>
                  <Text path={routeDetails.routeString} matchPath="activation">
                    {activationTextForDisplay}
                  </Text>
                  <RightArrow
                    src="/images/right-arrow.png"
                    width={20}
                    height={20}
                  />
                </NavItem>
                <Line />
              </a>
            </li>
            <li>
              <a onClick={() => goTo("/support", undefined, undefined, true)}>
                <NavItem onClick={openSupportMenu}>
                  <Text path={routeDetails.routeString} matchPath="support">
                    <Trans>Support</Trans>
                  </Text>
                  <RightArrow
                    src="/images/right-arrow.png"
                    width={20}
                    height={20}
                    isOpened={isOpened}
                  />
                </NavItem>
                <Line />
              </a>
            </li>
          </>
        )}
        <li>
          <NavAction>
            <Button
              text={onPartnerPage ? t("Personal") : t("Partners")}
              padding={onPartnerPage ? "5px 45px" : "5px 45px"}
              color={onPartnerPage ? "blue" : "darkBlue"}
              min={onPartnerPage ? "180px" : "165px"}
              onClick={() => {
                onPartnerPage
                  ? goTo("/", undefined, undefined, true)
                  : goTo("/partners", undefined, undefined, true);
              }}
            />
          </NavAction>
        </li>
        <li>
          <NavAction>
            <Button
              text={onPartnerPage ? t("Partner Portal") : t("My Account")}
              padding="5px 35px"
              color="white"
              min="165px"
              onClick={() => {
                onPartnerPage
                  ? window.open("https://partner.gophonebox.com/", "_self")
                  : goTo("/account", undefined, undefined, true);
              }}
            />
          </NavAction>
        </li>
        <li>
          <NavAction>
            <LanguageList border={"1px solid #0494CA"} color={"#0494CA"} />
          </NavAction>
        </li>
      </Ul>
    </Background>
  );
};

const Ul = styled.ul<{ open: boolean }>`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;

  li {
    padding-right: 60px;
  }

  flex-flow: column nowrap;
  background-color: #ecfaff;
  position: fixed;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  top: 0;
  right: 0;
  height: 100vh;
  width: 300px;
  padding-top: 3.5rem;
  transition: transform 0.3s ease-in-out;

  li {
    color: #fff;
  }

  @media (max-width: 768px) {
  }
`;

const Text = styled.p<{ path: string; matchPath: string }>`
  color: #149acd;
  font-weight: 400;
  white-space: nowrap;
  font-weight: ${(props) => (props.path === props.matchPath ? "700" : "400")};
`;

const SubText = styled.a`
  color: #000;
  font-weight: 400;
`;

const NavItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 16px;
`;
const NavAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 15px;
`;

const RightArrow = styled.img<{ isOpened?: boolean }>`
  filter: invert(64%) sepia(51%) saturate(7466%) hue-rotate(167deg)
    brightness(97%) contrast(84%);

  display: block;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;

  -webkit-transform: ${(props) =>
    props.isOpened ? "rotate(90deg)" : "rotate(0deg)"};
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
`;

const MyButton = styled.button`
  border-radius: 25px;
  background-color: #0494ca;
  border: none;
  color: #fff;
  text-align: center;
  font-size: 12px;
  padding: 5px;
  width: 50px;
  transition: all 0.5s;

  margin-top: 40px;
`;

const Menu = styled.p`
  color: #0494ca;
  font-weight: 700;
  font-size: 18px;
`;

interface props {
  open: boolean;
}

const Background = styled.div<props>`
  position: fixed;
  overflow: auto;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  display: ${({ open }) => (open ? "block" : "none")};
`;

export default RightNav;
